import React, { useEffect, useState, useRef } from "react";
import "../../CSS/CrownCss/CDashboard.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  set_dashboard_data,
  set_external_trend_info,
  SET_FETCH_TAG_VALUE_CONTROL,
} from "../../../Action/Action";

import Store from "../../../Store/Store";

const Popup = ({ x, y }) => {
  console.log(x, y);
};

const CDashboard = (props) => {
  const hjsu = {
    marginRight: "6%",
  };

  let elek_gün_ = null;
  let elek_ay_ = null;
  let elek_yıl_ = null;
  let su_gün_ = null;
  let su_yıl_ = null;
  let su_ay_ = null;
  let sıcak_sugün_ = null;
  let sıcak_su_ay_ = null;
  let sıcak_su_yıl_ = null;

  const history = useHistory();
  const [state, Set_state] = useState([]);

  const [pop_up_style, Set_pop_up_style] = useState({
    position: "fixed",
    width: "100px",
    height: "150px",
    background: "white",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  });

  const [misafir_oda, Set_misafir_oda] = useState({ misafir: 0, oda: 0 });

  let anlık_elektrik = "";
  let anlık_su = "";
  let anlık_sıcak_su = "";

  const showTagPopUp = (x_, y_) => {
    return <Popup x={x_} y={y_} />;
  };

  useEffect(() => {
    console.log(props.misafir_oda);
    Set_misafir_oda(props.misafir_oda);
  }, [props.misafir_oda]);

  useEffect(() => {
    console.log(props.dash_datas, anlık_elektrik, anlık_su, anlık_sıcak_su);
    Set_state(props.dash_datas);
  }, [props.dash_datas]);

  // Dashboard data fetch interval with proper cleanup
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/pages/GetDashboard",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        Store.dispatch(set_dashboard_data(data));
      } catch (err) {
        console.log("Dashboard fetch error:", err);
      } finally {
        Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
      }
    };

    // Initial fetch
    fetchDashboardData();

    // Set interval
    const intervalId = setInterval(fetchDashboardData, 35000);

    // Cleanup on unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  function handleContextMenu(e, item, tagName) {
    e.preventDefault();
    const { clientX, clientY } = e;
    console.log(clientX, clientY, item);

    const popup = document.querySelector(".show_external_trend");
    popup.classList.toggle("show_external_trend_active");

    document.querySelector(".show_tagId").innerHTML = item.tagId;
    document.querySelector(".show_tagName").innerHTML = tagName;

    const popupRect = popup.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let newX = clientX;
    let newY = clientY;

    if (newX + popupRect.width > viewportWidth) {
      newX = viewportWidth - popupRect.width;
    }

    if (newY + popupRect.height > viewportHeight) {
      newY = viewportHeight - popupRect.height;
    }

    if (newX < 0) {
      newX = 0;
    }

    if (newY < 0) {
      newY = 0;
    }

    popup.style.left = `${newX}px`;
    popup.style.top = `${newY}px`;

    showTagPopUp(clientX, clientY);
  }

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>

      <section className="main main_dashboard main_dashboard_section">
        <div></div>
        <div className="row elektrik-row">
          <h4 className="title">ELEKTRİK TÜKETİMLERİ</h4>

          {state.map((item, index) => {
            if (item.tagId === "557") {
              if (item.tip === "Günlük") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");

                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }

                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_gün_ = anlık_elektrik;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Aylık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");

                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }

                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_ay_ = anlık_elektrik;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Yıllık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");

                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }

                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_yıl_ = anlık_elektrik;

                console.log(elek_yıl_);

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (
                elek_gün_ !== null &&
                elek_ay_ !== null &&
                elek_yıl_ !== null
              ) {
                return (
                  <div
                    onContextMenu={(e) => handleContextMenu(e, item, tagName)}
                    className="box"
                  >
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Günlük : "}
                      <h4>{elek_gün_ + " " + item.tagUnit}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Aylık : "}
                      <h4>{elek_ay_ + " " + item.tagUnit}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Yıllık : "}
                      <h4>{elek_yıl_ + " " + item.tagUnit}</h4>
                    </p>
                  </div>
                );
              }
            }
          })}

          <div className="box4">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <h4 className="box4-gunayyil">Günlük</h4>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(elek_gün_) / misafir_oda.misafir).toFixed(2)}{" "}
                kWh
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(elek_gün_) / misafir_oda.oda).toFixed(2)}{" "}
                kWh
              </div>
            </div>
          </div>
          <div className="box4">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <h4 className="box4-gunayyil">Aylık</h4>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(elek_ay_) / misafir_oda.misafir).toFixed(2)}{" "}
                kWh
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(elek_ay_) / misafir_oda.oda).toFixed(2)}{" "}
                kWh
              </div>
            </div>
          </div>
          <div className="box4">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <h4 className="box4-gunayyil">Yıllık</h4>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(elek_yıl_) / misafir_oda.misafir).toFixed(2)}{" "}
                kWh
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(elek_yıl_) / misafir_oda.oda).toFixed(2)}{" "}
                kWh
              </div>
            </div>
          </div>
        </div>
        <div className="row su-row">
          <h4 className="title">SU TÜKETİMLERİ</h4>
          {state.map((item, index) => {
            if (item.tagId === "5011") {
              if (item.tip === "Günlük") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");

                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }

                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_su = String(last_değer2).replaceAll(",", ".");

                su_gün_ = anlık_su;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Aylık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");

                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_su = String(last_değer2).replaceAll(",", ".");

                su_ay_ = anlık_su;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Yıllık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_su = String(last_değer2).replaceAll(",", ".");

                su_yıl_ = anlık_su;

                console.log(su_yıl_);

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (su_gün_ !== null && su_ay_ !== null && su_yıl_ !== null) {
                return (
                  <div
                    onContextMenu={(e) => handleContextMenu(e, item, tagName)}
                    className="box"
                  >
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Günlük : "} <h4>{su_gün_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Aylık : "} <h4>{su_ay_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Yıllık : "} <h4>{su_yıl_ + " m³"}</h4>
                    </p>
                  </div>
                );
              }
            }
          })}
          ;
          <div className="box4 special">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(su_gün_) / misafir_oda.misafir).toFixed(2)}{" "}
                m³
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(su_gün_) / misafir_oda.oda).toFixed(2)}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(su_ay_) / misafir_oda.misafir).toFixed(2)}{" "}
                m³
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(su_ay_) / misafir_oda.oda).toFixed(2)}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(su_yıl_) / misafir_oda.misafir).toFixed(2)}{" "}
                m³
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(su_yıl_) / misafir_oda.oda).toFixed(2)}{" "}
                m³
              </div>
            </div>
          </div>
        </div>
        <div className="row sicaksu-row">
          <h4 className="title"> SICAK SU TÜKETİMLERİ</h4>
          {state.map((item, index) => {
            if (item.tagId === "5023") {
              if (item.tip === "Günlük") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_sıcak_su = String(last_değer2).replaceAll(",", ".");

                sıcak_sugün_ = anlık_sıcak_su;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Aylık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_sıcak_su = String(last_değer2).replaceAll(",", ".");

                sıcak_su_ay_ = anlık_sıcak_su;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Yıllık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_sıcak_su = String(last_değer2).replaceAll(",", ".");

                sıcak_su_yıl_ = anlık_sıcak_su;

                console.log(su_yıl_);

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (
                sıcak_sugün_ !== null &&
                sıcak_su_ay_ !== null &&
                sıcak_su_yıl_ !== null
              ) {
                return (
                  <div
                    onContextMenu={(e) => handleContextMenu(e, item, tagName)}
                    className="box"
                  >
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Günlük : "} <h4>{sıcak_sugün_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Aylık : "} <h4>{sıcak_su_ay_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Yıllık : "} <h4>{sıcak_su_yıl_ + " m³"}</h4>
                    </p>
                  </div>
                );
              }
            }
          })}

          <div className="box4 special">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(sıcak_sugün_) / misafir_oda.misafir).toFixed(2)}{" "}
                m³
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(sıcak_sugün_) / misafir_oda.oda).toFixed(2)}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(sıcak_su_ay_) / misafir_oda.misafir).toFixed(2)}{" "}
                m³
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(sıcak_su_ay_) / misafir_oda.oda).toFixed(2)}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(sıcak_su_yıl_) / misafir_oda.misafir).toFixed(2)}{" "}
                m³
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(sıcak_su_yıl_) / misafir_oda.oda).toFixed(2)}{" "}
                m³
              </div>
            </div>
          </div>
        </div>
        <div className="row elektrik-row">
          <h4 className="title">DOĞALGAZ TÜKETİMLERİ</h4>

          {state.map((item, index) => {
            if (item.tagId === "557") {
              if (item.tip === "Günlük") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_gün_ = anlık_elektrik;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Aylık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_ay_ = anlık_elektrik;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Yıllık") {
                function formatNumber(number) {
                  const parts = number.toString().split(".");
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_yıl_ = anlık_elektrik;

                console.log(elek_yıl_);

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (
                elek_gün_ !== null &&
                elek_ay_ !== null &&
                elek_yıl_ !== null
              ) {
                return (
                  <div
                    onContextMenu={(e) => handleContextMenu(e, item, tagName)}
                    className="box"
                  >
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Günlük : "}
                      <h4>{elek_gün_ + " " + item.tagUnit}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Aylık : "}
                      <h4>{elek_ay_ + " " + item.tagUnit}</h4>
                    </p>
                    <p
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Yıllık : "}
                      <h4>{elek_yıl_ + " " + item.tagUnit}</h4>
                    </p>
                  </div>
                );
              }
            }
          })}

          <div className="box4">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <h4 className="box4-gunayyil">Günlük</h4>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(elek_gün_) / misafir_oda.misafir).toFixed(2)}{" "}
                kWh
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(elek_gün_) / misafir_oda.oda).toFixed(2)}{" "}
                kWh
              </div>
            </div>
          </div>
          <div className="box4">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <h4 className="box4-gunayyil">Aylık</h4>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(elek_ay_) / misafir_oda.misafir).toFixed(2)}{" "}
                kWh
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(elek_ay_) / misafir_oda.oda).toFixed(2)}{" "}
                kWh
              </div>
            </div>
          </div>
          <div className="box4">
            <div className="div kat_basi">
              <p>Kişi Başı</p>
              <h4 className="box4-gunayyil">Yıllık</h4>
              <div className="value">
                {misafir_oda.misafir !== 0 &&
                  (Number(elek_yıl_) / misafir_oda.misafir).toFixed(2)}{" "}
                kWh
              </div>
            </div>
            <div className="div oda_basi">
              <p>Oda Başı</p>
              <div className="value">
                {misafir_oda.oda !== 0 &&
                  (Number(elek_yıl_) / misafir_oda.oda).toFixed(2)}{" "}
                kWh
              </div>
            </div>
          </div>
        </div>

        <div
          id="dashboard_bottom_row"
          style={{ justifyContent: "flex-start" }}
          className="row"
        >
          <div className="title_dash_alarms">ALARMLAR</div>
          <div
            onClick={() => {
              history.push("/notifications");
            }}
            className="kritik_alarm event_alarm"
          >
            <p>Event: </p>
            <h5>0</h5>
          </div>
          <div
            onClick={() => {
              history.push("/Alarmpanel");
            }}
            className="toplam_alarm alarm_alarm"
          >
            <p>Alarm: </p>
            <h5>{props.alarms.length}</h5>
          </div>
          <div className="box4 special alarmbox4">
            <div className="div kat_basi end-oran">
              <p>End.Oran</p>
              <div className="value">0</div>
            </div>
          </div>
          <div className="box4 special alarmbox4">
            <div className="div kat_basi kap-oran">
              <p>Kap.Oran</p>
              <div className="value">0</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    alarms: state.project_reducer.alarms,
    dash_datas: state.project_reducer.dashboard_datas,
    misafir_oda: state.project_reducer.misafir_oda,
    tags: state.project_reducer.tag_list,
  };
};

export default connect(MapStateToProps)(CDashboard);
